import React from 'react'
import Inner from '../component/Innerbanner'

// Helper component for structured service sections
const ServiceSection = ({ title, children }) => (
  <div className="mb-12">
    <h2 className="text-2xl font-bold text-gray-900 mb-4 border-b-2 border-teal-500 pb-2">
      {title}
    </h2>
    <div className="space-y-4 text-gray-600">
      {children}
    </div>
  </div>
);

// Helper component for printing methods comparison
const PrintMethod = ({ name, description, details }) => (
  <div className="p-6 bg-gray-50 rounded-lg shadow-sm hover:shadow-md transition duration-300">
    <h3 className="text-xl font-semibold text-teal-600 mb-2">{name}</h3>
    <p className="mb-3 italic">{description}</p>
    <ul className="list-disc ml-5 space-y-1 text-sm">
      {details.map((detail, index) => (
        <li key={index}>{detail}</li>
      ))}
    </ul>
  </div>
);

function Services() {
  return (
    <div className="font-custom">
      {/* Banner Component */}
      <Inner name="Our Services" title="Home . Services" />

      {/* --- Services Content Area --- */}
      <div className="bg-white py-16 sm:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <p className="text-center text-3xl font-bold text-gray-800 mb-16">
            Design & Print Custom Apparel for Any Occasion!
          </p>

          <ServiceSection title="1. Apparel & Product Customization">
            <p>
              We offer a vast catalog of apparel and accessories ready for your custom design. Whether it’s for a business, event, or personal use, we have the perfect canvas for your vision.
            </p>
            <div className="flex flex-wrap gap-4 text-sm font-medium text-white">
              <span className="px-3 py-1 bg-teal-500 rounded-full">T-Shirts (Basic & Premium)</span>
              <span className="px-3 py-1 bg-teal-500 rounded-full">Hoodies & Crewneck Sweats</span>
              <span className="px-3 py-1 bg-teal-500 rounded-full">Polos & Jackets</span>
              <span className="px-3 py-1 bg-teal-500 rounded-full">Custom Hats & Beanies</span>
              <span className="px-3 py-1 bg-teal-500 rounded-full">Youth Apparel</span>
            </div>
          </ServiceSection>

          <ServiceSection title="2. Print & Decoration Methods">
            <p>
              We utilize state-of-the-art technology to ensure your design looks fantastic on any product. Choose the method that best suits your design, budget, and quantity needs.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <PrintMethod
                name="Screen Printing"
                description="The traditional, durable, and cost-effective choice for bulk orders."
                details={[
                  "Ideal for large order quantities (minimum typically 12 pieces).",
                  "Best for designs with fewer colors.",
                  "Offers volume discounts.",
                  "Highly durable print quality."
                ]}
              />
              <PrintMethod
                name="Digital Printing (DTG)"
                description="Perfect for detailed, full-color designs with no minimum order requirements."
                details={[
                  "No minimum order required (order a single shirt).",
                  "Unlimited color usage (great for photographs).",
                  "Super fast turnaround time.",
                  "Directly prints the image onto the shirt."
                ]}
              />
              <PrintMethod
                name="Embroidery"
                description="A professional, high-end look, often used for business apparel and hats."
                details={[
                  "Ideal for logos on polos, hats, and jackets.",
                  "Creates a textured, premium finish.",
                  "Durable and long-lasting.",
                  "Minimum order quantities typically apply."
                ]}
              />
            </div>
          </ServiceSection>

          <ServiceSection title="3. Design & Order Support">
            <p>
              Our services extend beyond just printing; we provide the tools and support to make your creative process seamless, from concept to delivery.
            </p>
            <ul className="list-disc ml-5 space-y-2">
              <li>
                **Online Design Studio:** Use our easy-to-use platform with thousands of free clip art, fonts, and customizable templates, or simply upload your own logo/image.
              </li>
              <li>
                **Art Team Review:** Every order is reviewed by our expert art team who check for common errors like alignment and misspellings, making automatic adjustments when necessary.
              </li>
              <li>
                **No Hidden Fees:** Pricing is all-inclusive, and determined by the number of print locations and colors (for screen print).
              </li>
              <li>
                **Shipping & Delivery:** We offer options for fast turnaround and standard delivery directly to your door.
              </li>
            </ul>
          </ServiceSection>

        </div>
      </div>
    </div>
  )
}

export default Services